import {BrandType} from '../../../provider/brands/brand-type';
import {UserType} from '../../user/user-type';

import {ReviewRealtimeHelpLinkConfigType} from './review-realtime-presence-config';

function getBrandCounterpartyId(brandId: number, brands: Array<BrandType>): number | null {
    const counterpartyId = brands.find((brand) => brand.id === brandId)?.counterpartyId;

    return typeof counterpartyId === 'number' ? counterpartyId : null;
}

function isReviewRealtimeAllowedCounterparty(
    counterpartyId: number,
    config: ReviewRealtimeHelpLinkConfigType
): boolean {
    if (config.available) {
        return true;
    }

    return (config.counterpartyIds ?? []).includes(counterpartyId);
}

function isReviewRealtimeAllowedForBrand(
    brandId: number,
    brands: Array<BrandType>,
    config: ReviewRealtimeHelpLinkConfigType
): boolean {
    if (config.available) {
        return brands.some((brand) => brand.id === brandId);
    }

    const counterpartyId = getBrandCounterpartyId(brandId, brands);

    if (counterpartyId === null) {
        return false;
    }

    return isReviewRealtimeAllowedCounterparty(counterpartyId, config);
}

export function canSendReviewRealtime(
    user: UserType | null,
    brandId: number,
    brands: Array<BrandType>,
    config: ReviewRealtimeHelpLinkConfigType | null
): boolean {
    if (!user || !config) {
        return false;
    }

    if (user.isStaff && !config.staffCanSend) {
        return false;
    }

    return isReviewRealtimeAllowedForBrand(brandId, brands, config);
}

export function canReceiveReviewRealtime(
    user: UserType | null,
    brandId: number,
    brands: Array<BrandType>,
    config: ReviewRealtimeHelpLinkConfigType | null
): boolean {
    if (!user || !config) {
        return false;
    }

    return isReviewRealtimeAllowedForBrand(brandId, brands, config);
}

export function hasAnyReviewRealtimeReceiveBrand(
    user: UserType | null,
    brands: Array<BrandType>,
    config: ReviewRealtimeHelpLinkConfigType | null
): boolean {
    if (!user || !config) {
        return false;
    }

    if (config.available) {
        return brands.length > 0;
    }

    return brands.some((brand) => {
        if (typeof brand.counterpartyId !== 'number') {
            return false;
        }

        return isReviewRealtimeAllowedCounterparty(brand.counterpartyId, config);
    });
}
